"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _CardActionButton = require("./CardActionButton");

var _CardActionButton2 = _interopRequireDefault(_CardActionButton);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
/**
 * Simple wrapper for `CardActionButton` for apps built using
 * a previous version of the component library.
 */


var CardAction = function CardAction(props) {
  return _react2.default.createElement(_CardActionButton2.default, props);
};

exports.default = CardAction;